/**
 *  Validates a URL and returns true or false
 */
export const isValidUrl = (value, base) => {
    try {
        new URL(value, base);
        return true;
    }
    catch {
        return false;
    }
};
/**
 * Validates and returns a URL string if validation is enabled
 */
const validateIfNeeded = (value, validate, base) => {
    if (!validate)
        return value;
    return isValidUrl(value, base) ? value : undefined;
};
/**
 * Attempts to extract URL from object properties (default or src)
 */
const extractFromObject = (val) => {
    const defaultUrl = val['default'];
    if (typeof defaultUrl === 'string')
        return defaultUrl;
    const srcUrl = val['src'];
    if (typeof srcUrl === 'string')
        return srcUrl;
    return undefined;
};
/**
 * Safely coerces value to string
 */
const tryCoerceToString = (val) => {
    try {
        return String(val);
    }
    catch {
        return undefined;
    }
};
/**
 * Normalizes thumbnail URL from various input types with optional validation
 */
export const normalizeThumbnailUrl = (value, opts) => {
    const validate = !!opts?.validate;
    const base = opts?.base;
    // Treat null/undefined as missing
    if (value === null || value === undefined)
        return undefined;
    // Handle string values
    if (typeof value === 'string') {
        return validateIfNeeded(value, validate, base);
    }
    // Symbols are not valid thumbnail values
    if (typeof value === 'symbol')
        return undefined;
    // Handle objects that may come from imported modules or image loaders
    if (typeof value === 'object') {
        const extracted = extractFromObject(value);
        if (extracted !== undefined) {
            return validateIfNeeded(extracted, validate, base);
        }
    }
    // For other types, try safe coercion
    const result = tryCoerceToString(value);
    if (result === undefined)
        return undefined;
    return validateIfNeeded(result, validate, base);
};
export default normalizeThumbnailUrl;
